

function toggleFilter() {
    const body = document.getElementById('filterBody');
    body.style.display = body.style.display === 'none' ? 'block' : 'none';
}


document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("filterBody");

  if (!container) return;

  container.addEventListener("change", function (e) {
    const target = e.target;

    // CLEAR ALL
    if (target.id === "clearAllFilters") {
      const url = new URL(window.location.href);

      // Remove all filter params
      url.search = "";

      applyFilters(url.toString());

      // Uncheck all
      container.querySelectorAll("input").forEach(input => input.checked = false);
      target.checked = true;

      return;
    }

    // PRICE FILTER (single select)
    if (target.classList.contains("price-filter")) {
      const url = new URL(window.location.href);

      container.querySelectorAll(".price-filter").forEach(cb => cb.checked = false);
      target.checked = true;

      url.searchParams.set("filter.v.price.lte", target.dataset.price);

      applyFilters(url.toString());
      return;
    }

    // NORMAL FILTERS
    if (target.dataset.url) {
      applyFilters(target.dataset.url);
    }
  });

  function applyFilters(url) {
    fetch(url)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");

        // Use ONE consistent selector
        const newGrid =
          doc.querySelector("#ProductGridContainer") ||
          doc.querySelector("#product-grid");

        const currentGrid =
          document.querySelector("#ProductGridContainer") ||
          document.querySelector("#product-grid");

        if (newGrid && currentGrid) {
          currentGrid.innerHTML = newGrid.innerHTML;
        }

        window.history.pushState({}, "", url);
      })
      .catch(err => console.error("Filter error:", err));
  }
});
const container = document.getElementById("filterBody");
const anyChecked = container.querySelectorAll("input:checked").length > 0;
const clearAll = document.getElementById("clearAllFilters");

if (!anyChecked && clearAll) {
  clearAll.checked = true;
}

function applyFilters(url) {
  const loader = document.getElementById("filterLoader");

  // SHOW loader
  if (loader) loader.classList.remove("hidden");

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newGrid =
        doc.querySelector("#ProductGridContainer") ||
        doc.querySelector("#product-grid");

      const currentGrid =
        document.querySelector("#ProductGridContainer") ||
        document.querySelector("#product-grid");

      if (newGrid && currentGrid) {
        currentGrid.innerHTML = newGrid.innerHTML;
      }

      window.history.pushState({}, "", url);
    })
    .catch(err => console.error("Filter error:", err))
    .finally(() => {
      // HIDE loader
      if (loader) loader.classList.add("hidden");
    });
}


document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".facets-container");
  const whatsappIcon = document.querySelector(".wsp-whatsapp");
  
  const footer = document.querySelector(".shopify-section-group-footer-group");

  let isFooterVisible = false;

  const observer = new IntersectionObserver(
    ([entry]) => {
      isFooterVisible = entry.isIntersecting;
      updateHeader();
    },
    {
      root: null,
      threshold: 0.1
    }
  );

  if (footer) observer.observe(footer);

  window.addEventListener("scroll", updateHeader);

  function updateHeader() {
    if (isFooterVisible) {
      header.classList.remove("filter-active");
      header.classList.add('hidden-filter')
      return;
    }else{
        header.classList.remove("hidden-filter")
    }

    if (window.scrollY > 10) {
      header.classList.add("filter-active");
      whatsappIcon && whatsappIcon.classList.add("active");
    } else {
      header.classList.remove("filter-active");
      whatsappIcon && whatsappIcon.classList.remove("active");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let removeBtn = document.querySelector(".mobile-facets__clear-wrapper");

  if (removeBtn) {
    removeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector('#FacetFiltersFormMobile').reset()
      document.querySelectorAll('.facets-wrap input[type="checkbox"]').forEach((checkbox) => {
        checkbox.checked = false;
      });
    });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const closeBtn = document.querySelector('.cross-btn-filter');

  if (!closeBtn) return;

  closeBtn.addEventListener("click", function () {
    const drawer = document.querySelector(".mobile-facets__disclosure");
    const summary = drawer.querySelector('.mobile-facets__open-wrapper ')

    if (drawer && drawer.hasAttribute("open")) {
      drawer.removeAttribute("open");
      drawer.classList.remove('menu-opening')
      summary.setAttribute("aria-expanded", false)

    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const disclosure = document.querySelector(".mobile-facets__disclosure");

  if (!disclosure) return;

  const toggleScroll = () => {
    if (disclosure.hasAttribute("open")) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  };

  // Run on load
  toggleScroll();

  // Watch for open/close changes
  const observer = new MutationObserver(toggleScroll);
  observer.observe(disclosure, { attributes: true, attributeFilter: ["open"] });
});

document.addEventListener("DOMContentLoaded", () => {
  const clearAll = document.getElementById("clearAllFilters");

  if (!clearAll) return;

  clearAll.addEventListener("click", (e) => {
    e.preventDefault();

    // 1. Uncheck all inputs visually
    document.querySelectorAll('#filterBody input[type="checkbox"]').forEach(input => {
      input.checked = false;
    });

    // 2. Remove all active filters using their remove URLs
    const activeFilters = document.querySelectorAll('#filterBody input[data-url][checked], #filterBody input[data-url]:checked');

    activeFilters.forEach(input => {
      const url = input.getAttribute("data-url");

      if (url) {
        fetch(url)
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, "text/html");

            // Replace product grid (IMPORTANT: update selector as per your theme)
            const newGrid = doc.querySelector(".product-grid");
            const currentGrid = document.querySelector(".product-grid");

            if (newGrid && currentGrid) {
              currentGrid.innerHTML = newGrid.innerHTML;
            }

            // Update URL without reload
            window.history.pushState({}, "", url);
          });
      }
    });

    // 3. Reset custom price filters
    document.querySelectorAll('.price-filter').forEach(input => {
      input.checked = false;
    });
  });
});

// collections page filter 

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pill input').forEach((input) => {
    input.addEventListener('change', function () {
      const label = this.closest('.pill');

      if (this.checked) {
        label.classList.add('active');
      } else {
        label.classList.remove('active');
      }
    });
  });
});


